// 节假日发货提示语-品类
export enum FestivalCat {
    '蛋糕'  = 1,
    '鲜花',
    '蛋糕+鲜花'
}